export default {
  testing: '/portal/sensorTesting/',
}
